import flatpickr from 'flatpickr'
require("flatpickr/dist/flatpickr.css")
require("flatpickr/dist/themes/material_blue.css");

document.addEventListener("turbolinks:load", () => {
  flatpickr("[data-behavior='flatpickr']", {
    allowInput: true
  })
})

document.addEventListener("turbolinks:load", () => {
  flatpickr("[data-behavior='flatpickr-range']", {
    enableTime: true,
    allowInput: true,
    mode: 'range'
  })
})
